import { type NextPageContext } from 'next'

import { getAllItemCategories } from '@flecto/api/store'
import { getStoreByDomain } from '@flecto/api/store'

import { useFlattenCategories } from '../../hooks/useStoreFlattenCategories'

export async function getServerSideProps(context: NextPageContext) {
  const redirectToFlecto = {
    redirect: {
      destination: 'https://flecto.io',
      permanent: false,
    },
  }

  const isApexDomain = !['flecto.store', 'vercel.app'].some((domain) =>
    context.req?.headers.host?.includes(domain)
  )

  const domain = String(
    isApexDomain ? context.req?.headers.host : context.query.storeId
  )

  try {
    const store = await getStoreByDomain(domain)

    const storeDomain = store?.domain || ''
    const { item_category } = await getAllItemCategories(storeDomain)
    const itemCategories = useFlattenCategories(item_category)

    if (!store.enabled) {
      return redirectToFlecto
    }

    return {
      props: {
        store,
        itemCategories,
      },
    }
  } catch {
    return redirectToFlecto
  }
}
